module.exports = __webpack_public_path__ + "img/pellets-bigbag.cd75434.svg";